import audio from '../../../../assets/audio/kids-tracks/Text13.mp3';
import busstop from '../../../../assets/images/games/zdar-kids-game/busstop.webp';

export const step14stop = {
    id: 14,
    title: 'Zastávka',
    taskText: `
        <p>
            Když jsem byl malý kocour, tak mi dědeček vyprávěl, že tu kdysi bývala budka, kam chodil odpočívat. 
            Z ní byl hezký výhled na celý kostel. Jednoho dne sem ale přišli lidé a budku dědečkovi zbořili. 
            Místo toho tu postavili toto velké místo, kde odpočívají různé dopravní prostředky.
        </p>
    `,
    cipher: {
        text: `
            Zkus vyjmenovat co nejvíce dopravních prostředků co znáš. 
        `,
        images: [busstop],
        label: 'Úkol',
    },
    continueButtonText: 'Hotovo',
    points: true,
    audio: audio,
    hints: [
        {
            text: 'Tak třeba auto, motorka, tramvaj, letadlo, vlak, autobus, loď ...',
        },
    ],
};
